import React from 'react';
import { ContentfulTheme } from '@jbhi-fi/apis/src/contentful/types';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { ThemeTransformer } from '@jbhi-fi/components/src/Contentful/transformers/ThemeTransformer';

export type ContentTheme = {
  backgroundColor: string;
  textColor: string;
  icon?: React.ReactNode;
};

export const defaultContentTheme: ContentTheme = {
  backgroundColor: '#232323',
  textColor: '#FFF',
};

/**
 * @deprecated Use ThemeTransformer.toContentThemeVariables instead
 */
export const contentfulApiThemeToContentThemeProps = (entry: ContentfulTheme | undefined): ContentTheme => {
  const theme = ThemeTransformer.toContentThemeVariables(entry);
  return {
    textColor: theme.palette?.text ?? defaultContentTheme.textColor,
    backgroundColor: theme.palette?.background ?? defaultContentTheme.backgroundColor,
    icon: entry?.fields?.icon?.fields ? <Icon name={entry.fields.icon.fields.name} /> : null,
  };
};
